import React from 'react';
import Icon from "../";
export default function IconCheck(props) {
  return React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<polyline points=\"3.32 12.86 8.9 19.4 20.99 5.26\" fill=\"none\" stroke=\"#181818\"/>"
    }
  }));
}